module.exports = __webpack_public_path__ + "static/media/regenerate.95d59379.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/statusEffects/regenerate.png
// module id = 150
// module chunks = 0